import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import moment from 'moment';
import { ButtonGroup, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import _ from 'lodash';

import NoData from '../../../components/NoData/NoData';
import { overviewIsLoading, setPageName } from './../../App/AppActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker } from '../../../components/Filter/components';
import { setChart } from '../../../components/Filter/FilterActions';
import { getData} from '../OverviewActions';
import { getSelectionValues } from '../../../util/filterUtils';
import { trackTeamDashboardView, trackTabChange } from '../../../util/mixpanel';

import CFDChart from '../components/CFD';
import CTSPChart from '../components/CTSP';
import CTBChart from '../components/CTB';
import CTHChart from '../components/CTH';
import CTAChart from '../components/CTA';
import TRCChart from '../components/TRC';

// Import Styles
import './../Overview.scss';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.tooltipParentRef = React.createRef();

    this.state = {
      oct: 0,
      ct: 0,
      wip: 0,
      wipAvgAge: 0,
      showFlowMetrics: false,
      showProcessImprovement: false
    };

    props.dispatch(setPageName('Overview'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.dispatch(setChart('overview'));

      trackTeamDashboardView('overview');
    }

    if (this.props.ctsp && this.props.ctsp.percentiles && this.props.ctsp.percentiles.length) {
      this.updateCycleTime();
    }

    if (this.props.cta && this.props.cta.series && this.props.cta.series.length) {
      this.updateAvgAge();
    }

    if (this.props.cfd && this.props.cfd.length) {
      this.updateWip();
    }
  }

  componentDidUpdate(prevProps) {
    this.isLoaded();   
    if (
      (prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.excludeWeekends !== this.props.excludeWeekends ||
        prevProps.workStart !== this.props.workStart ||
        prevProps.workEnd !== this.props.workEnd ||
        !_.isEqual(prevProps.holidays, this.props.holidays) ||
        prevProps.enabledColors !== this.props.enabledColors) &&
      this.props.dataIsLoading === false
    ) {
      this.getData();
    }

    if (
      (prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.excludeWeekends !== this.props.excludeWeekends ||
        prevProps.workStart !== this.props.workStart ||
        prevProps.workEnd !== this.props.workEnd ||
        !_.isEqual(prevProps.holidays, this.props.holidays) ||
        prevProps.enabledColors !== this.props.enabledColors) &&
      this.props.overviewLoading
    ) {
      this.setState({ pendingUpdate: true });
    }

    if (
      prevProps.overviewLoading !== this.props.overviewLoading &&
      !this.props.overviewLoading &&
      this.state.pendingUpdate
    ) {
      this.setState({ pendingUpdate: false });
      this.getData();
    }

    if (prevProps.ctsp != this.props.ctsp) {
      this.updateCycleTime();
    }

    if (prevProps.cta != this.props.cta) {
      this.updateAvgAge();
    }

    if (prevProps.cfd != this.props.cfd) {
      this.updateWip();
    }
  }

  updateCycleTime() {
    const eightyfifth = _.find(this.props.ctsp.percentiles, p => p.name == '85');
    if (eightyfifth) {
      this.setState({
        ct: eightyfifth.rawValue
      });
    }

    const overviewEightyFifth = _.find(this.props.ctsp.percentiles, p => p.name == '85');
    this.setState({
      oct: overviewEightyFifth ? overviewEightyFifth.rawValue : 0
    });
  }

  updateAvgAge() {
    const wipAvgAge = _(this.props.cta.series)
      .flatMap('data')
      .meanBy('cycleTimeInMinutes');

    this.setState({
      wipAvgAge
    });
  }

  updateWip() {
    let wip = 0;
    _(this.props.cfd)
      .filter(l => {
        return (
          l.listId !== 'done' &&
          this.props.dashboard.todo.indexOf(l.listId) === -1 &&
          this.props.dashboard.done.indexOf(l.listId) === -1
        );
      })
      .forEach(l => {
        let last = _.last(l.data);
        wip += last.daily;
      });

    this.setState({
      wip
    });
  }

  isLoaded() {
    if (
      this.props.overviewLoading &&
      !this.props.cfdLoading &&
      !this.props.cthLoading &&
      !this.props.ctspLoading &&
      !this.props.ctaLoading &&
      !this.props.thLoading &&
      !this.props.trcLoading &&
      !this.props.ctAnalysisLoading &&
      !this.props.ctbAnalysisLoading &&
      !this.props.wipAnalysisLoading &&
      !this.props.wipAgeAnalysisLoading &&
      !this.props.thAnalysisLoading &&
      !this.props.feAnalysisLoading
    ) {
      this.props.dispatch(overviewIsLoading(false));
    }
  }

  getData() {
    if (!this.props.dataIsLoading && !this.props.overviewLoading) {
      this.props.dispatch(overviewIsLoading(true));
      this.props.dispatch(getData());
    }
  }

  renderSystemMetrics() {
    let stats = _.first(this.props.cfdStats);

    let systemAvgArrivalRate = stats ? stats.avgArrivalRate : 0.0;
    let systemAvgThroughput = stats ? stats.avgThroughput : 0.0;
    let systemAvgDailyWIP = stats ? stats.avgDailyWIP : 0;
    let systemAvgCycleTime = moment
      .duration(stats ? stats.avgCycleTime : 0, 'days')
      .format(this.props.timePrecision, { trim: 'mid both' });

    return (
      <div className='info-box-content'>
        <div className='info-box-item'>
          <h4>{systemAvgArrivalRate.toFixed(2)}</h4>
          <p>Arrival Rate items/day</p>
        </div>
        <div className='info-box-item'>
          <h4>{systemAvgThroughput.toFixed(2)}</h4>
          <p>Throughput items/day</p>
        </div>
        <div className='info-box-item'>
          <h4>{systemAvgDailyWIP.toFixed(2)}</h4>
          <p>Daily WIP items</p>
        </div>
        <div className='info-box-item'>
          <h4>{systemAvgCycleTime}</h4>
          <p>Cycle Time</p>
        </div>
      </div>
    );
  }


  // handleClick = () => {
  //   this.switchOverview(OVERVIEW_TYPES.PROCESS_IMPROVEMENT);

  //   if (this.props.dashboard && this.props.user) {
  //     trackTabChange(this.props.dashboard.name, 'Flow Metrics & Analytics', 'Process Improvement', this.props.user.status);
  //   }
  // };

  // handleClickOverview = () => {
  //   this.switchOverview(OVERVIEW_TYPES.FLOW_METRICS);

  //   if (this.props.dashboard && this.props.user) {
  //     trackTabChange(this.props.dashboard.name, 'Process Improvement', 'Flow Metrics & Analytics', this.props.user.status);
  //   }
  // };

  tooltipWidth() {
    return this.tooltipParentRef.current ? `${this.tooltipParentRef.current.offsetWidth - 5}px` : 'auto';
  }

  render() {
    const { queueLists, allQueueLists } = this.props;
    const showFlowEfficiency = getSelectionValues(queueLists, allQueueLists).length < allQueueLists.length;

    const totalActiveItems = !this.props.cta ? 0 : _.reduce(this.props.cta.series, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);

    const totalCompletedItems = !this.props.ctsp ? 0 : _.reduce(this.props.ctsp.series, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);

    const totalItems = totalActiveItems + totalCompletedItems;

    const tresholdsCalculationsTooltip = (
      <Tooltip id="tresholdsTooltip" className='tooltip_white calculate_info' style={{ width: this.tooltipWidth() }}>
        Your thresholds are set by analyzing a time-ordered sequence of data, using between 4 to 20 data points (with 20 as the default).
        <br></br>
        <br></br>
        To flag a low or high status for your flow metrics, we look for a signal—a significant deviation from your typical process behavior.
        <br></br>
        <br></br>
        When a signal is detected, the benchmarks are frozen, and no new data points are included. Once at least 4 new data points are available, they are used to establish a new baseline.
      </Tooltip>
    );

    return (
      <div className='background_gray overview_page'>
        <Helmet title={`Overview${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`} />
        <Filter totalItems={totalItems} isOverview colors disabledLists={['todo']} />
        <div className='overview'>
          <div className='overview-header'>
            <div className='overview-header-right-elements' ref={this.tooltipParentRef}>
             <DatePicker />
            </div>
          </div>

          <React.Fragment>
            <div className="row-cell-list" >
              <div className={`cell cell-sm-height ${showFlowEfficiency && 'cell-25'}`}>
                <div className='cell-header'><h4>Cycle Time</h4></div>
                <div className="cell-content cell-justify-center">
                  <div className='info-box-item'>
                    <h4>{`${moment.duration(this.state.oct, 'minutes').format(this.props.timePrecision, {trim: 'mid both'})} or less`}</h4>
                    <p>were needed to complete</p>
                  </div>
                  <div className='info-box-item'>
                    <h4>85%</h4>
                    <p>work items</p>
                  </div>
                </div>
              </div>
            
              <div className={`cell cell-sm-height ${showFlowEfficiency && 'cell-25'}`}>
                <div className='cell-header'><h4>WIP</h4></div>
                <div className='cell-content cell-justify-center'>
                  <div className='info-box-item'>
                    <h4>
                      {this.state.wip} work item{this.state.wip != 1 ? 's' : ''}
                    </h4>
                    <p>{this.state.wip != 1 ? 'are' : 'is'} currently in progress</p>
                  </div>
                  <div className='info-box-item'>
                    <h4>
                      {moment
                        .duration(this.state.wipAvgAge, 'minutes')
                        .format(this.props.timePrecision, { trim: 'mid both' })}
                    </h4>
                    <p>WIP average age</p>
                  </div>
                </div>
              </div>
              
              {showFlowEfficiency && (
                <div className='cell cell-sm-height cell-25'>
                  <div className='cell-header'><h4>Flow Efficiency</h4></div>
                  <div className='cell-content cell-justify-center '>
                    <div className='info-box-item'>
                      <h4>{this.props.avgFe.avgFe || '0.00'}%</h4>
                      <p>Average Flow Efficiency</p>
                    </div>
                  </div>
                </div>
              )}
                
              <div className={`cell cell-sm-height ${showFlowEfficiency && 'cell-25'}`}>
                <div className='cell-header'><h4>Process Metrics</h4></div>
                <div className='cell-content cell-justify-center'>
                  {this.renderSystemMetrics()}
                </div>
              </div>

              <div className='cell'>
                <div className='cell-header'><h4>Cumulative Flow Diagram</h4></div>
                {this.props.cfd.length > 0 &&
                  <div className='cell-content'>
                    <CFDChart id="Overview_CFD" className="chart" data={this.props.cfd} />
                  </div>
                }
                
                <NoData
                  className="cell-content overview_CFD"
                  show={!this.props.cfd.length}
                  loading={this.props.cfdLoading}
                />
                <Link className='link' to={`/dashboard/${this.props.dashboard._id}/cfd`}></Link>
              </div>

              <div className='cell'>
                <div className='cell-header'><h4>Cycle Time Scatterplot</h4></div>
                {(this.props.ctsp.series && this.props.ctsp.series.length > 0) &&
                  <div className='cell-content'>
                    <CTSPChart id="Overview_CTSP" className="chart" data={this.props.ctsp} />
                  </div>
                }
                
                <NoData
                  className="cell-content overview_CTSP"
                  show={this.props.ctsp.series && !this.props.ctsp.series.length}
                  loading={this.props.ctspLoading}
                />
                <Link className='link' to={`/dashboard/${this.props.dashboard._id}/ctsp`}></Link>
              </div>

              <div className='cell'>
                <div className='cell-header'><h4>Cycle Time Breakdown Chart</h4></div>
                {(this.props.ctb.breakdown && this.props.ctb.breakdown.length > 0) &&
                  <div className='cell-content'>
                    <CTBChart id="Overview_CTB" className="chart" data={this.props.ctb.breakdown} />
                  </div>
                }

                <NoData
                  className="cell-content overview_CTB"
                  show={this.props.ctb.breakdown && !this.props.ctb.breakdown.length}
                  loading={this.props.ctbLoading}
                />
                <Link className='link' to={`/dashboard/${this.props.dashboard._id}/ctb`}></Link>
              </div>

              <div className='cell'>
                <div className='cell-header'><h4>Cycle Time Histogram</h4></div>
                {(this.props.cth.series && this.props.cth.series.length > 0) &&
                  <div className='cell-content'>
                    <CTHChart id="Overview_CTH" className="chart" data={this.props.cth} />
                  </div>
                }

                <NoData
                  className="cell-content overview_CTH"
                  show={this.props.cth.series && !this.props.cth.series.length}
                  loading={this.props.cthLoading}
                />
                <Link className='link' to={`/dashboard/${this.props.dashboard._id}/cth`}></Link>
              </div>

              <div className='cell'>
                <div className='cell-header'><h4>Aging Chart</h4></div>
                {(this.props.cta.series && this.props.cta.series.length > 0) &&
                  <div className='cell-content'>
                    <CTAChart id="Overview_CTA" className="chart" data={this.props.cta} />
                  </div>
                }

                <NoData
                  className="cell-content overview_CTA"
                  show={this.props.cta.series && !this.props.cta.series.length}
                  loading={this.props.ctaLoading}
                />
                <Link className='link' to={`/dashboard/${this.props.dashboard._id}/cta`}></Link>
              </div>

              <div className='cell'>
                <div className='cell-header'><h4>Throughput Run Chart</h4></div>
                {this.props.trc.length &&
                  <div className='cell-content'>
                    <TRCChart id="Overview_TRC" className="chart" data={this.props.trc} />
                  </div>
                }

                <NoData 
                  className="cell-content overview_TRC"
                  show={!this.props.trc.length} 
                  loading={this.props.trcLoading} 
                />
                <Link className='link' to={`/dashboard/${this.props.dashboard._id}/trc`}></Link>
              </div>
             
            </div>
          </React.Fragment>          
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    user: state.auth.user,
    enabledColors: state.filters.enabledColors,
    timePrecision: state.filters.timePrecision,
    excludeWeekends: state.filters.excludeWeekends,
    workStart: state.filters.workStart,
    workEnd: state.filters.workEnd,
    holidays: state.filters.holidays,
    queueLists: state.filters.overview.selectedQueueLists,
    allQueueLists: state.filters.allQueueLists,
    hash: state.filters.overview.hash,

    overviewLoading: state.app.overviewLoading,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,

    dashboard: state.dashboards.selected,

    overviewType: state.overview.overviewType,
    cfd: state.overview.cfd,
    cfdLoading: state.overview.cfdLoading,
    cfdStats: state.overview.cfdStats,
    ctsp: state.overview.ctsp,
    ctspLoading: state.overview.ctspLoading,
    ctb: state.overview.ctb,
    ctbLoading: state.overview.ctbLoading,
    cth: state.overview.cth,
    cthLoading: state.overview.cthLoading,
    cta: state.overview.cta,
    ctaLoading: state.overview.ctaLoading,
    trc: state.overview.trc,
    trcLoading: state.overview.trcLoading,
    avgFe: state.overview.avgFe,    
  };
};

export default connect(mapStateToProps)(Overview);
